<template>
    <div style="width: 100%;" class="datatable-filters">
    <v-col v-resize="onResize" >
        <app-card-expansible>
            <template v-slot:title>
                <div class="d-flex flex-column" style="flex: 0 0 auto !important">
                    <v-card-title class="d-flex justify-space-between align-center title-text dark-blue-color mx-1" :class="subtitleName ? 'pb-0 pt-3' : ''" data-cy="card-title-datatable-filter">
                        {{ tb(name) }}
                    </v-card-title>
                    <span v-if="subtitleName" class="subtitle-text align-self-end dark-blue-color" style="padding-bottom: 0px; padding-right: 16px; margin-right: 4px !important">{{ tb(subtitleName) }}</span>
                </div>
            </template>

            <template v-slot:actions>
                <v-btn v-if="name=='Encomenda Normal' && isTablet || name=='Encomenda Affinity' && isTablet || name=='Encomenda Favoritos' && isTablet || name=='Produtos Pendentes' && isTablet || name=='Simposium Veterinário' && isTablet" class="btn-qrcode-scanner tablet" icon @click="openQrcodeScanner">
                        <v-icon class="v-icon notranslate dark-blue-color theme--light">mdi-barcode-scan</v-icon>
                </v-btn>
                <v-btn  v-if="isTablet" class="myprovet-btn-search tablet" icon @click="$emit('refresh')">
                    {{ tb('Filtrar') }}
                        <!--<v-icon class="v-icon notranslate dark-blue-color theme--light">mdi-filter</v-icon>-->
                </v-btn>
                <v-btn   v-if="isTablet&&!hasActiveFilters || isTablet && !areAdvancedFiltersActive || isTablet && hasActiveFilters || isTablet && areAdvancedFiltersActive" class="btn-qrcode-scanner  myprovet-btn-clear  tablet" icon  @click="clearFilters"  >
                    {{ tb('Limpar') }}
                        <!---<v-icon class="v-icon notranslate dark-blue-color theme--light">mdi-filter-remove-outline</v-icon>-->
                </v-btn>

                <v-tooltip v-if="false && showReplacementProductsButton" bottom open-on-hover content-class="myprovet-tooltip">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" icon class="appbar-icon-button-small btn-bg-color-white dark-blue-color mr-2" style="cursor: pointer" @click="toggleReplacementProducts">
                            <product-replacement-icon></product-replacement-icon>
                        </v-btn>
                    </template>
                    <span>{{ $t('table.substituteProducts') }}</span>
                </v-tooltip>

                <v-tooltip v-if="false && advanced_filters && userStore.hasPermissionTo('View advanced filters')" bottom open-on-hover content-class="myprovet-tooltip">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            v-bind="attrs"
                            v-on="on"
                            class="appbar-icon-button-small mr-2"
                            :class="{
                                'btn-bg-color-white dark-blue-color': !areAdvancedFiltersActive,
                                'btn-bg-color-white red--text': areAdvancedFiltersActive,
                            }"
                            style="cursor: pointer"
                            @click.stop="isAdvancedFiltersDialogOpen = true"
                            data-cy="advanced-filters-btn"
                        >
                            mdi-filter-plus-outline
                        </v-icon>
                    </template>

                    <span>{{ $t('table.advancedFilters') }}</span>
                </v-tooltip>

                <!-- Checking Account buttons -->
                <div v-if="isCheckingAccount" class="d-flex align-center">
                    <!-- TODO: Hide for now. Payment will be made invoice by invoice at this time. -->
                    <!-- <v-btn text outlined class="myprovet-btn-checking-account px-8 mr-2" @click="$emit('open-generate-payment-dialog')">
                        <img class="rotate-360-svg" src="/storage/assets/gerarpagamento.svg" />
                        &nbsp;&nbsp;Gerar Pagamento
                    </v-btn> -->

                    <v-btn v-if="userStore.hasPermissionTo('Send PDF with financial details')" text outlined class="myprovet-btn-checking-account px-8 mr-2" @click="$emit('open-checking-account-dialog')">
                        <img class="rotate-360-svg" src="/storage/assets/enviarCCorrente.svg" />
                        <!-- <v-icon left> mdi-credit-credit-card-fast</v-icon> -->
                        &nbsp;&nbsp;{{ tb('Conta Corrente') }}
                    </v-btn>
                </div>
            </template>

            <template v-slot:content>
                <v-row>
                    <v-col :md="isTablet?'12':'10'" sm="12">
                        <v-row v-if="showMessage && message !== ''">
                            <v-col md="12" class="pt-1">
                                <div class="px-3 py-3 font-size-sm blocked-background dark-red-color" style="border-radius: 16px !important" v-html="tHtml(message)"></div>
                            </v-col>
                        </v-row>

                        <portal-target name="v-form-base" style="width: 100%" />
                    </v-col>

                    <v-col  :md="name=='Encomenda Normal' && isTablet || name=='Encomenda Affinity' && isTablet || name=='Encomenda Favoritos' && isTablet || name=='Produtos Pendentes' && isTablet || name=='Simposium Veterinário' && isTablet?'0':'2'" class="d-flex flex-column pb-0">
                        <v-spacer v-if="!showSpecialFilterView"></v-spacer>

                        <div v-if="showGraphTypeSelection" class="d-flex flex-column spacer">
                            <v-radio-group class="data-table-filters-side-radio" v-if="changeViewTypeEnabled" :value="graphViewType" @change="$emit('view-type-changed', $event)" mandatory>
                                <template v-slot:label>
                                    <div class="pb-2">{{ $t('table.viewType') }}</div>
                                </template>
                                <v-radio :label="$t('table.grid')" value="table"></v-radio>
                                <v-radio :label="$t('table.chart')" value="graph"></v-radio>
                            </v-radio-group>
                        </div>

                        <div v-if="showOperatorSelection && !isTablet" class="d-flex flex-column spacer">
                            <v-radio-group class="data-table-filters-side-radio" v-if="changeViewTypeEnabled" :value="operatorType" @change="$emit('operator-changed', $event)" mandatory>
                                <template v-slot:label>
                                    <div class="pb-2">{{ $t('table.cumulativeOperator') }}</div>
                                </template>
                                <v-radio :label="$t('table.and')" value="all"></v-radio>
                                <v-radio :label="$t('table.or')" value="any"></v-radio>
                            </v-radio-group>
                        </div>

                        <v-btn text outlined class="myprovet-btn-cancel mb-2" @click="clearFilters" v-if="!isTablet && hasActiveFilters || !isTablet&&areAdvancedFiltersActive"> {{ $t('table.clear') }} </v-btn>
                        <v-btn text class="myprovet-btn-ok" data-cy="filters-filter-btn" @click="$emit('refresh')" v-if="!isTablet"> {{ $t('table.filter') }} </v-btn>
                    </v-col>
                </v-row>

                <v-row no-gutters class="mt-5 mb-2" style="min-height: 26px" v-if="hasFiltersWithArrayType">
                    <v-col>
                        <div v-if="!hasExpandedActiveFilters" ref="collapsedFilter">
                            <span class="dark-blue-color table-filters-text pt-0">{{ $t('orders.base.activeFilters') }}</span>

                            <product-active-filters v-for="(filterType, index) in filtersWithArrayType" :key="index" :items="filterType" :schema="schema" @remove-filter="$emit('remove-filter', filterType, $event)"> </product-active-filters>
                        </div>

                        <div v-else>
                            <v-expansion-panels accordion tile flat v-model="activeFiltersActivePanelIndex">
                                <v-expansion-panel>
                                    <v-expansion-panel-header v-if="activeFiltersActivePanelIndex !== 0" class="elevation-0 table-filters-text pt-0 active-filters-listing" expand-icon="mdi-pan-down"> {{ tb('Clique aqui para ver os filtros ativos.') }} </v-expansion-panel-header>

                                    <v-expansion-panel-header v-else class="elevation-0 table-filters-text pt-0 active-filters-listing" expand-icon="mdi-pan-down"> {{ tb('Clique aqui para esconder os filtros ativos.') }} </v-expansion-panel-header>

                                    <v-expansion-panel-content>
                                        <v-card class="btn-bg-color-gray filters-list-card">
                                            <v-card-title ref="expandedFilter" class="ma-2 mt-0">
                                                <div class="inner-filters-list-card">
                                                    <product-active-filters v-for="(filterType, index) in filtersWithArrayType" :key="index" :items="filterType" :schema="schema" @remove-filter="$emit('remove-filter', filterType, $event)"> </product-active-filters>
                                                </div>
                                            </v-card-title>
                                        </v-card>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </div>
                    </v-col>
                </v-row>
                <v-row v-else no-gutters class="mt-5 mb-2"> </v-row>
            </template>
        </app-card-expansible>

        <app-dialog :value="isAdvancedFiltersDialogOpen" @input="isAdvancedFiltersDialogOpen = $event" :title="$t('table.advancedFilters')" width="45vw">
            <template v-slot:content>
                <query-builder :query="advancedFilters" @input="advancedFilters = $event" :rules="advanced_filters"></query-builder>
            </template>

            <template v-slot:buttons="{}">
                <v-btn text outlined class="myprovet-btn-cancel" @click="isAdvancedFiltersDialogOpen = false" data-cy="app-dialog-advance-filters-close-btn"> {{ $t('common.close') }} </v-btn>

                <v-btn text outlined class="myprovet-btn-ok" @click="applyAdvancedFilters(advancedFilters)" data-cy="app-dialog-advance-filters-ok-btn"> {{ $t('table.filter') }} </v-btn>
            </template>
        </app-dialog>

    </v-col>
    <qrcode-scanner-dialog  :qrStyle="qrstyle" :qrWidth="qrwidth"  :qrHeight="qrheight" :value="qrcodeDialogOpen"  @input="qrcodeDialogOpen = $event"  @onCancel="qrcodeDialogOpen = false" width="100vw" max-height="60vh"> </qrcode-scanner-dialog>
</div>
</template>

<script>
import { validateAdvancedFilters } from '@arentia/atools/QueryBuilder';
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { useAppStore } from '@/Stores/app';
import { axios } from '@/Services/Backend';

export default {
    props: {
        isAffinity: {
            type: Boolean,
            default: false,
        },
        isCheckingAccount: {
            type: Boolean,
            default: false,
        },
        showGraphTypeSelection: {
            type: Boolean,
            default: false,
        },
        showOperatorSelection: {
            type: Boolean,
            default: false,
        },
        changeViewTypeEnabled: {
            type: Boolean,
            default: false,
        },
        graphViewType: {
            type: String,
            default: 'table',
        },
        operatorType: {
            type: String,
            default: 'all',
        },
        showMessage: {
            type: Boolean,
            default: false,
        },
        messageUrl: {
            type: String,
            default: '',
        },
        showReplacementProductsButton: {
            type: Boolean,
            default: false,
        },
        name: String,
        subtitleName: String,
        hasActiveFilters: Boolean,
        hasExpandedActiveFilters: Boolean,
        areAdvancedFiltersActive: Boolean,
        advanced_filters: Array,
        filters: Object,
        schema: Object,
    },

    data: () => ({
        activeFiltersActivePanelIndex: null,
        isAdvancedFiltersDialogOpen: false,
        advancedFilters: {
            logicalOperator: 'all',
            children: [],
        },
        message: '',
        qrcodeDialogOpen:false,
        qrwidth:'340',
        qrheight:'340',
        qrstyle:''
    }),

    created() {
        if (this.showMessage && this.messageUrl !== '') {
            this.getMessage();
        }

        window.EventBus.$on('check-if-should-overflow', this.checkIfShouldOverflow);
        window.EventBus.$on('check-if-should-underflow', this.checkIfShouldUnderflow);
        if(!this.isMobile){
            this.checkIfToOpenEanReader();
        }

    },

    beforeDestroy() {
        window.EventBus.$off('check-if-should-overflow', this.checkIfShouldOverflow);
        window.EventBus.$off('check-if-should-underflow', this.checkIfShouldUnderflow);
    },

    computed: {
        ...mapStores(useUserStore,useAppStore),

        filtersWithArrayType() {
            // Some arrays are not supposed to be listed (like branches for example, as the list could become extremely big for admins, etc).
            const keys = Object.keys(this.filters).filter((f) => f != 'branch__id' && f != 'branches##id' && Array.isArray(this.filters[f]));

            return keys.map((k) => this.filters[k]);
        },

        hasFiltersWithArrayType() {
            return this.filtersWithArrayType.flat().length;
        },

        showSpecialFilterView() {
            return this.showGraphTypeSelection || this.showOperatorSelection;
        },
        isMobile(){
            return this.appStore.is_mobile
        },
        isTablet(){
            return this.appStore.is_tablet
        },
    },

    methods: {
        checkIfToOpenEanReader(){
            const urlParams = new URLSearchParams(window.location.search);
            const eanReader = urlParams.get('eanReader');
            if(eanReader=='true'){
                this.qrcodeDialogOpen=!this.qrcodeDialogOpen
                window.EventBus.$emit('update:startQRCODE', true)
                var newURL = location.href.split("?")[0];
                setTimeout(()=>{
                    window.history.pushState({}, document.title,newURL)
                })
            }
        },
        onResize(){
            let orientation = window.matchMedia("(orientation: portrait)")

            if(window.innerWidth>=1024 && window.innerHeight<=1266 && orientation.matches){
                this.qrwidth='380'
                this.qrheight='260'
            }else if(window.innerWidth>=1024 && window.innerHeight<=1266 && !orientation.matches){
                this.qrwidth='380'
                this.qrheight='260'

            }else if(window.innerWidth>=1024 && window.innerHeight>=1266 && orientation.matches){
                this.qrwidth='480'
                this.qrheight='280'

            }else if(window.innerWidth>=1267 && window.innerHeight >=1366 && !orientation.matches){
                this.qrwidth='480'
                this.qrheight='280'
            }else{
                this.qrwidth='360'
                this.qrheight='260'
            }
        },
        openQrcodeScanner(){
          this.qrcodeDialogOpen=!this.qrcodeDialogOpen
          if(this.qrcodeDialogOpen){
            window.EventBus.$emit('update:startQRCODE', true)
          }
          //console.log('openQrcodeScanner',this.qrcodeDialogOpen);
        },
        clearFilters() {
            // @Order matters here
            window.EventBus.$emit('clear-table-filters');
            this.$emit('clear-filters');
        },

        applyAdvancedFilters() {
            let advancedFiltersValidationErrors = validateAdvancedFilters(this.advancedFilters);
            if (advancedFiltersValidationErrors.length > 0) {
                advancedFiltersValidationErrors.forEach((error) => {
                    this.showError(error);
                });
                return;
            }
            this.$emit('apply-advanced-filters', this.advancedFilters);
            this.isAdvancedFiltersDialogOpen = false;
        },

        checkIfShouldOverflow() {
            // We need to run on the next tick because the new filter should be added first.
            this.$nextTick(() => {
                const element = this.$refs.collapsedFilter;
                if (!element) return;

                let sizeAfter = element.clientHeight;
                if (sizeAfter > 30) this.$emit('expand-active-filters', true);
            });
        },

        checkIfShouldUnderflow() {
            const wasExpanded = this.activeFiltersActivePanelIndex === 0;
            const hadOverflow = this.hasExpandedActiveFilters;

            // To calculate the space, we need to show all of the filters.
            this.$emit('expand-active-filters', false);

            // We need to run on the next tick because the filters need to be in the DOM.
            this.$nextTick(() => {
                const element = this.$refs.collapsedFilter;
                if (!element) return;

                let isUnderflowing = element.clientHeight < 45;

                if (isUnderflowing) this.$emit('expand-active-filters', false);
                // If the user had the active filters opened, keep it open.
                if (hadOverflow && wasExpanded && !isUnderflowing) {
                    this.$emit('expand-active-filters', true);
                    this.activeFiltersActivePanelIndex = 0;
                }
            });
        },

        toggleReplacementProducts() {
            for (const property in this.schema) {
                if (property && property.startsWith('substitutes')) {
                    this.schema[property].hidden = !this.schema[property].hidden;
                }
            }
        },

        getMessage() {
            axios
                .get(this.messageUrl)
                .then((response) => {
                    this.message = response.data;
                })
                .catch((error) => {
                    console.log(error);
                    this.showError(this.$t('orders.pending.alertLoadError'));
                });
        },
    },
};
</script>

<style>
.myprovet-btn-checking-account {
    /* border: 1px solid #b8b8b8 !important; */
    -webkit-box-shadow: 0px 0px 0px 1px rgb(0 0 0 / 5%);
    box-shadow: 0px 0px 0px 1px rgb(0 0 0 / 5%);
    box-sizing: border-box !important;
    /* border-radius: 2px !important; */
    min-width: 100px !important;
    max-width: 200px !important;
    width: 100% !important;
    height: 25px !important;
    color: #154579 !important;
    font-style: normal !important;
    font-weight: bold;
    font-size: 12px !important;
    /* line-height: 18px !important; */
    padding-top: 3px !important;
    /* float: right !important; */
    text-transform: none !important;
}
</style>

<style>
.data-table-filters-side-radio {
    margin-top: 10px !important;
}

.filters-list-card {
    position: absolute;
    right: 0px;
    top: 31px;
}

.inner-filters-list-card {
    width: 100%;
    max-height: 40vh;
    overflow-y: auto;
}
</style>
